Revolution.Module.extend({
    NAME: "mde.search-choices", // OBLIGATOIRE (reflète l'arborescence répertoire : /mde/main.js)

    initialize: function ($) {
        this.mobileSearch();
        this.hideShowPanel();
        this.navtab();
        this.showChoiceMenu();
    },

    onWindowLoad: function (e) {
        setTimeout(function(){
            $( window ).resize();
            console.log('resize');
        },100);
    },

    onWindowScroll: function (e) {

    },
    onWindowResize: function (e) {

    },
    mobileSearch: function(){

        // declaring selector
        var selectors = {
            choices: '.bk-choices',
            choicesBtn: '.bk-choices-button',
        }

        // class used to active
        var classes = {
            active: 'active'
        }

        var animationDuration = 400; //milliseconds

        // toggle display search choices
        $(selectors.choicesBtn).on('click', function(e){
            var $that = $(this);
            $(selectors.choices).slideToggle({
                duration: animationDuration ,
                start: function(){
                    $that.toggleClass(classes.active);
                }
            });
        });
    },
    
    hideShowPanel: function(){

        // declaring selector
        var selectors = {
            choiceContent: ".bk-choices-content",
            choices: ".bk-choices > li > a",
            dataPanel: 'data-search-panel',
            searchContent: '.search-content',
            searchContentName: 'search-content',
            close: '.close-panel'
        };
        var classes = {
            active: 'active'
        }
        var animationDuration = 400; //milliseconds

        var slideToggleOptions = {
            duration: animationDuration,
            progress: function(){

                // give a div the height of content with animation
                var curentHeight = $(this).outerHeight(true);
                $(selectors.choiceContent).height(curentHeight);
            }
        };

        // remove active class function
        var removeActiveClass = function($this){
            $(selectors.choices).each(function(index,ele){

                if($($this)[0] != ele){
                    $(this).removeClass(classes.active);     
                }
            });
        }
        // adapte height of content width externale div
        var adaptingHeight = function(){
            var curentHeight;
            $(selectors.searchContent).each(function(){
                if($(this).css('display') != 'none'){
                    curentHeight = $(this).outerHeight(true);
                    $(selectors.choiceContent).height(curentHeight);
                }
            });
        }

        // click on choices to show the content using slideToggle fun
        $(selectors.choices).on('click', function(e){
            e.preventDefault();

            // remove active class
            removeActiveClass(this);

            // add active class 
            $(this).toggleClass(classes.active);

            // close content if it show up
            var selector = $(this).attr(selectors.dataPanel);
            $(selectors.searchContent).each(function(index,ele){
                if($(selector)[0] != ele){
                    $(ele).slideUp({
                        duration: 0
                    });
                }
            });

            //show the content or closet
            $(selector).slideToggle(slideToggleOptions);
        });


        // fix div hieght after click 
        $('body').on('click', function(event){
            var contentClick = $(event.target).closest(selectors.searchContent).length > 0;
            var closeClick = ($(event.target).closest(selectors.close).length > 0) || ($(event.target)[0] == $(selectors.close)[0]);
            if(contentClick && !closeClick){
                adaptingHeight();
            }
        });

        //close panel
        $(selectors.close).on('click', function(){
            $(selectors.searchContent).slideUp(slideToggleOptions);
            // remove active class
            removeActiveClass();
        });

        //adaptiong height of div on resize
        $( window ).resize(adaptingHeight);
        
    },
    navtab: function(){

        var selectors = {
            parentClickElementClass: '.nav-tabs',
            clickElement: $('.nav-tabs .nav-link'),
            PrentElementShowsClass: '.tab-content',
            PrentElementShows: $('.tab-content'),
            elementshoaws: $('.tab-pane')
        }

        var removeActive = function(that){
            $(that).closest(selectors.parentClickElementClass).find('.active').removeClass('active');
            $(that).closest(selectors.parentClickElementClass).next(selectors.PrentElementShowsClass).find('.active').removeClass('active');
        }

        var addActive  = function(that){
            // select id
            var id = $(that).attr('data-toggle');

            //add active to nav link
            $(that).addClass('active');

            //add active to tab content panel
            $(that).closest(selectors.parentClickElementClass).next(selectors.PrentElementShowsClass).find(id).addClass('active');

        }

        //if the element link exist
        if(selectors.clickElement){
            selectors.clickElement.on('click',function(e){
                e.preventDefault();
                if( !$(this).hasClass('active') ){
                    removeActive(this);
                    addActive(this);
                }
            }); 
        }
    },
    showChoiceMenu: function() {
        if ($('.bk-choices').length) {

            if ($(window).width() > 960) {

                var btnOffset = $('.bk-choices').offset().top - 20;
                $('.bk-choices > li > a').on('click', function(e){
                    e.preventDefault();
                    
                    $('html, body').animate({
                        scrollTop: btnOffset
                    }, 500);
                });
            }
        }
    }
});